export default __webpack_public_path__ + "static/media/status_old.661f3920.svg";